// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleOffers_wrapper__lmR6o","icon":"SingleOffers_icon__H6657","whole":"SingleOffers_whole__+adD7","title":"SingleOffers_title__0E3BC"};